/* eslint-disable @typescript-eslint/no-explicit-any */
import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import { GETMODULEACTIONS, GETROLESLITE, GRIDROLES, ROLES } from '../endpoints';

export const getRoles = async () => {
  const response = await client.get(`${baseUrl}/roles`);
  return response;
};

export const createRole = async (body: {
  roleName: string;
  description: string;
  permissions: {
    module: string;
    actions: string[];
  }[];
}) => {
  const response = await client.post(`${baseUrl}/roles`, body);
  return response;
};

export const getModuleActions = async () => {
  const response = await client.get(`${baseUrl}${GETMODULEACTIONS}`);
  return response;
};

export const removeRole = async (roleId: number) => {
  const response = await client.delete(`${baseUrl}/roles/${roleId}`);
  return response;
};

export const editRoleById = async (
  id: string,
  body: {
    roleName: string;
    description: string;
    permissions: {
      module: string;
      actions: string[];
    }[];
  }
) => {
  const payloadWithId = { ...body, roleId: id };
  const response = await client.put(`${baseUrl}/roles`, payloadWithId);
  return response;
};

export const getGridRoles = async ({
  page,
  size,
  q,
}: {
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(`${baseUrl}${GRIDROLES}`, {
    params: {
      page,
      size,
      q,
    },
  });
  return response;
};

export const getLiteRoles = async () => {
  const response = await client.get(`${baseUrl}${GETROLESLITE}`);
  return response;
};

export const getRoleById = async (roleId: number) => {
  const response = await client.get(`${baseUrl}${ROLES}/${roleId}`);
  return response;
};
